import consts from "../main/consts";

export class StorageUser {
  constructor() {
    this.info = StorageUser.USER_INFO;
  }

  getValue(key) {
    return (StorageUser.USER_INFO && StorageUser.USER_INFO[key]) || null;
  }

  getRole() {
    const role = this.getValue("role");
    const loja = this.getValue("loja");
    // const key = role['*'] ? '*' : this.getValue('loja');
    return role && (role["*"] || role[loja]);
  }

  getRoles() {
    const roles = this.getValue("roles");
    return roles || [];
  }

  allowedByPermission(permissionName) {
    const roles = this.getRoles();
    if (roles.length === 0) {
      localStorage.removeItem("apptoken");
      localStorage.removeItem("userInfo");
      window.location = consts.LOGOUT_URL;
      return false;
    }
    return !!roles.find((role) => role === permissionName);
  }

  static get USER_INFO() {
    return JSON.parse(localStorage.getItem("userInfo"));
  }
}
